export default "__VITE_ASSET__BGY5$Pzj__"